import { useCallback, useRef, useState } from 'react';

import { useInstanceEffect } from '@/scenarios/legacy-player/hooks/useInstanceEffect';
import { usePlayerInstance } from '@/scenarios/legacy-player/lib/contexts/instance';

import { PlayingState } from '../types/instance';

export const usePlayingState = () => {
    const instance = usePlayerInstance();
    const [playingState, setPlayingState] = useState<PlayingState | undefined>(
        () => instance?.playingState
    );
    const previousState = useRef<PlayingState | undefined>();

    const onPlayingStateChange = useCallback((newState: PlayingState | undefined) => {
        setPlayingState((currentState) => {
            previousState.current = currentState;
            return newState;
        });
    }, []);

    useInstanceEffect((instance) => instance.onPlayingStateChange(onPlayingStateChange));

    return { playingState, previousPlayingState: previousState.current };
};
